// https://github.com/jaywcjlove/hotkeys#supported-keys
export default {

  // Game navigation
  radios: 'c',
  decoder: 'd',
  files: 'f',
  inventory: 'i',
  map: 'm',
  notebook: 'n',

  config: 'g',

  // Arrow keys for map screen
  gameMapLeft: 'left',
  gameMapRight: 'right',
  gameMapUp: 'up',
  gameMapDown: 'down'

}
